import { makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Toastmessage from "../../../Common/ToastMessage";
import { useHistory } from "react-router";
import { Header, Container, DocumentsContainer } from "./styles";
import { getDocumentsSentToSignature } from "../../../../services/signature.service";
import { useAuth } from "../../../../context/auth";
import { checkAccess } from "../../utils/index";
import { useTranslation } from "react-i18next";
import DocumentItem from "./DocumentItem";

const useStyles = makeStyles((theme) => ({
  titleModal: {
    color: "#031795",
    fontWeight: "bold",
    fontSize: "20px",
  },
}));

interface IMinuteDocsSentToSignModalProps {
  actionShowSpinner: (value: boolean) => void;
  setModalStatus: React.Dispatch<React.SetStateAction<boolean>>;
  minuteId: string;
}

export interface IDocument {
  minuteEnvelopeId: string;
  companyId: string;
  docusignEnvelopeId: string;
  minuteId: string;
  name: string;
  sentAt: string;
  status: string;
}

const MinuteDocsSentToSignModal = ({
  setModalStatus,
  minuteId,
}: IMinuteDocsSentToSignModalProps) => {
  const { userAccess } = useAuth() as any;
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();

  const [toastMessage, setToastMessage] = useState({
    content: "",
    type: "error",
    open: false,
    autoHideDuration: 4000,
  });

  const [canSeeDocumentSignatures, setCanSeeDocumentSignatures] =
    useState(false);

  const [documents, setDocuments] = useState<IDocument[]>([]);

  useEffect(() => {
    if (userAccess) {
      const hasAccess = checkAccess(userAccess, "listDocumentsSentToSign");
      const hasAccessToSeeDocumentSignatures = checkAccess(
        userAccess,
        "listDocumentSignatures"
      );

      setCanSeeDocumentSignatures(hasAccessToSeeDocumentSignatures);

      if (!hasAccess || !minuteId) {
        history.push("/");

        return;
      }

      const fetchMinuteDocuments = async () => {
        try {
          const response = await getDocumentsSentToSignature(minuteId);

          setDocuments(response.data);
        } catch (error) {
          setToastMessage({
            content: t("forms.minutes.signatures.viewDocumentsError"),
            type: "error",
            open: true,
            autoHideDuration: 4000,
          });

          return;
        }
      };

      fetchMinuteDocuments();
    }
  }, [minuteId, userAccess]);

  return (
    <>
      <Toastmessage
        message={toastMessage.content}
        type={toastMessage.type}
        open={toastMessage.open}
        autoHideDuration={toastMessage.autoHideDuration}
        close={() =>
          setToastMessage({
            open: false,
            content: "",
            type: "",
            autoHideDuration: 4000,
          })
        }
      />
      <Container>
        <Header>
          <span
            style={{ float: "right", cursor: "pointer" }}
            onClick={() => {
              setModalStatus(false);
            }}
          >
            [X] {t(`forms.minutes.signatures.closeModalButton`)}
          </span>
          <span className={classes.titleModal}>
            {t(`forms.minutes.signatures.sentDocumentos`)}
          </span>
        </Header>

        <DocumentsContainer>
          {documents.map((document) => (
            <DocumentItem
              canSeeDocumentSignatures={canSeeDocumentSignatures}
              document={document}
              key={document.docusignEnvelopeId}
            />
          ))}
        </DocumentsContainer>
      </Container>
    </>
  );
};

export default MinuteDocsSentToSignModal;
